export enum CONCURRENT_USAGE_ERROR_CODES {
    TIMESHEET_OUTDATED = 'CONCURRENT_USAGE_TIMESHEET_OUTDATED',
    NOTIFICATIONS_OUTDATED = 'CONCURRENT_USAGE_NOTIFICATIONS_OUTDATED',
}
